export default __webpack_public_path__ + "static/media/left-chevron-icon.5b6099a7.svg";